import { render, staticRenderFns } from "./RealWorldCare.vue?vue&type=template&id=0570ce28&scoped=true"
import script from "./RealWorldCare.vue?vue&type=script&lang=js"
export * from "./RealWorldCare.vue?vue&type=script&lang=js"
import style0 from "./RealWorldCare.vue?vue&type=style&index=0&id=0570ce28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570ce28",
  null
  
)

export default component.exports